// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/clients.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  Address,
  AddressJson,
  AddressValid,
  AuditUpdater,
  AuditUpdaterJson,
  Pagination,
  PaginationJson,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/clients.proto.
 */
export const file_proto_v1_clients: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZwcm90by92MS9jbGllbnRzLnByb3RvEhN2bXNwZGIuYXBpLnByb3RvLnYxIlsKDkNsaWVudExpY2Vuc2VzEikKIWdlbmVyYWxfY29udHJhY3Rvcl9saWNlbnNlX251bWJlchgBIAEoCRIeChZlcHNjX2NvbnRyYWN0b3JfbnVtYmVyGAIgASgJIjEKF0NsaWVudFNlcnZpY2VHZXRSZXF1ZXN0EhYKBHV1aWQYASABKAlCCLpIBXIDsAEBIoAFChhDbGllbnRTZXJ2aWNlR2V0UmVzcG9uc2USFgoEdXVpZBgBIAEoCUIIukgFcgOwAQESDAoEbmFtZRgCIAEoCRItCgR0eXBlGAMgASgOMh8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRUeXBlEhUKDWJ1c2luZXNzX25hbWUYBCABKAkSDQoFZW1haWwYBSABKAkSFAoMcGhvbmVfbnVtYmVyGAYgASgJEi0KB2FkZHJlc3MYByABKAsyHC52bXNwZGIuYXBpLnByb3RvLnYxLkFkZHJlc3MSPQoMbm90aWZpY2F0aW9uGAggASgOMicudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnROb3RpZmljYXRpb24SNQoIbGljZW5zZXMYCSABKAsyIy52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudExpY2Vuc2VzElEKCmF0dHJpYnV0ZXMYCiADKAsyPS52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudFNlcnZpY2VHZXRSZXNwb25zZS5BdHRyaWJ1dGVzRW50cnkSFAoMYXNzb2NpYXRpb25zGAsgAygJEi4KCmNyZWF0ZWRfYXQYHSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYHiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjIKB3VwZGF0ZXIYHyABKAsyIS52bXNwZGIuYXBpLnByb3RvLnYxLkF1ZGl0VXBkYXRlchoxCg9BdHRyaWJ1dGVzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASLgAwoaQ2xpZW50U2VydmljZUNyZWF0ZVJlcXVlc3QSFAoEbmFtZRgCIAEoCUIGukgDyAEBEi0KBHR5cGUYAyABKA4yHy52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudFR5cGUSFQoNYnVzaW5lc3NfbmFtZRgEIAEoCRINCgVlbWFpbBgFIAEoCRIUCgxwaG9uZV9udW1iZXIYBiABKAkSLQoHYWRkcmVzcxgHIAEoCzIcLnZtc3BkYi5hcGkucHJvdG8udjEuQWRkcmVzcxI9Cgxub3RpZmljYXRpb24YCCABKA4yJy52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudE5vdGlmaWNhdGlvbhI1CghsaWNlbnNlcxgJIAEoCzIjLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50TGljZW5zZXMSUwoKYXR0cmlidXRlcxgKIAMoCzI/LnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZUNyZWF0ZVJlcXVlc3QuQXR0cmlidXRlc0VudHJ5EhQKDGFzc29jaWF0aW9ucxgLIAMoCRoxCg9BdHRyaWJ1dGVzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASKGBQobQ2xpZW50U2VydmljZUNyZWF0ZVJlc3BvbnNlEhYKBHV1aWQYASABKAlCCLpIBXIDsAEBEgwKBG5hbWUYAiABKAkSLQoEdHlwZRgDIAEoDjIfLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50VHlwZRIVCg1idXNpbmVzc19uYW1lGAQgASgJEg0KBWVtYWlsGAUgASgJEhQKDHBob25lX251bWJlchgGIAEoCRItCgdhZGRyZXNzGAcgASgLMhwudm1zcGRiLmFwaS5wcm90by52MS5BZGRyZXNzEj0KDG5vdGlmaWNhdGlvbhgIIAEoDjInLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50Tm90aWZpY2F0aW9uEjUKCGxpY2Vuc2VzGAkgASgLMiMudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRMaWNlbnNlcxJUCgphdHRyaWJ1dGVzGAogAygLMkAudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlQ3JlYXRlUmVzcG9uc2UuQXR0cmlidXRlc0VudHJ5EhQKDGFzc29jaWF0aW9ucxgLIAMoCRIuCgpjcmVhdGVkX2F0GB0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GB4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIyCgd1cGRhdGVyGB8gASgLMiEudm1zcGRiLmFwaS5wcm90by52MS5BdWRpdFVwZGF0ZXIaMQoPQXR0cmlidXRlc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEi8AMKGkNsaWVudFNlcnZpY2VVcGRhdGVSZXF1ZXN0EhYKBHV1aWQYASABKAlCCLpIBXIDsAEBEgwKBG5hbWUYAiABKAkSLQoEdHlwZRgDIAEoDjIfLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50VHlwZRIVCg1idXNpbmVzc19uYW1lGAQgASgJEg0KBWVtYWlsGAUgASgJEhQKDHBob25lX251bWJlchgGIAEoCRItCgdhZGRyZXNzGAcgASgLMhwudm1zcGRiLmFwaS5wcm90by52MS5BZGRyZXNzEj0KDG5vdGlmaWNhdGlvbhgIIAEoDjInLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50Tm90aWZpY2F0aW9uEjUKCGxpY2Vuc2VzGAkgASgLMiMudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRMaWNlbnNlcxJTCgphdHRyaWJ1dGVzGAogAygLMj8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlVXBkYXRlUmVxdWVzdC5BdHRyaWJ1dGVzRW50cnkSFAoMYXNzb2NpYXRpb25zGAsgAygJGjEKD0F0dHJpYnV0ZXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIoYFChtDbGllbnRTZXJ2aWNlVXBkYXRlUmVzcG9uc2USFgoEdXVpZBgBIAEoCUIIukgFcgOwAQESDAoEbmFtZRgCIAEoCRItCgR0eXBlGAMgASgOMh8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRUeXBlEhUKDWJ1c2luZXNzX25hbWUYBCABKAkSDQoFZW1haWwYBSABKAkSFAoMcGhvbmVfbnVtYmVyGAYgASgJEi0KB2FkZHJlc3MYByABKAsyHC52bXNwZGIuYXBpLnByb3RvLnYxLkFkZHJlc3MSPQoMbm90aWZpY2F0aW9uGAggASgOMicudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnROb3RpZmljYXRpb24SNQoIbGljZW5zZXMYCSABKAsyIy52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudExpY2Vuc2VzElQKCmF0dHJpYnV0ZXMYCiADKAsyQC52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudFNlcnZpY2VVcGRhdGVSZXNwb25zZS5BdHRyaWJ1dGVzRW50cnkSFAoMYXNzb2NpYXRpb25zGAsgAygJEi4KCmNyZWF0ZWRfYXQYHSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYHiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjIKB3VwZGF0ZXIYHyABKAsyIS52bXNwZGIuYXBpLnByb3RvLnYxLkF1ZGl0VXBkYXRlchoxCg9BdHRyaWJ1dGVzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASI0ChpDbGllbnRTZXJ2aWNlRGVsZXRlUmVxdWVzdBIWCgR1dWlkGAEgASgJQgi6SAVyA7ABASKGBQobQ2xpZW50U2VydmljZURlbGV0ZVJlc3BvbnNlEhYKBHV1aWQYASABKAlCCLpIBXIDsAEBEgwKBG5hbWUYAiABKAkSLQoEdHlwZRgDIAEoDjIfLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50VHlwZRIVCg1idXNpbmVzc19uYW1lGAQgASgJEg0KBWVtYWlsGAUgASgJEhQKDHBob25lX251bWJlchgGIAEoCRItCgdhZGRyZXNzGAcgASgLMhwudm1zcGRiLmFwaS5wcm90by52MS5BZGRyZXNzEj0KDG5vdGlmaWNhdGlvbhgIIAEoDjInLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50Tm90aWZpY2F0aW9uEjUKCGxpY2Vuc2VzGAkgASgLMiMudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRMaWNlbnNlcxJUCgphdHRyaWJ1dGVzGAogAygLMkAudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlRGVsZXRlUmVzcG9uc2UuQXR0cmlidXRlc0VudHJ5EhQKDGFzc29jaWF0aW9ucxgLIAMoCRIuCgpjcmVhdGVkX2F0GB0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GB4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIyCgd1cGRhdGVyGB8gASgLMiEudm1zcGRiLmFwaS5wcm90by52MS5BdWRpdFVwZGF0ZXIaMQoPQXR0cmlidXRlc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEi3gEKGENsaWVudFNlcnZpY2VMaXN0UmVxdWVzdBIOCgZmaWx0ZXIYASABKAkSEgoKcGFnZV9pbmRleBgCIAEoDRIbCglwYWdlX3NpemUYAyABKA1CCLpIBSoDGIgnEjoKDnNvcnRfZGlyZWN0aW9uGAQgASgOMiIudm1zcGRiLmFwaS5wcm90by52MS5Tb3J0RGlyZWN0aW9uEhYKCnNvcnRfZmllbGQYBSABKAlCAhgBEi0KBHNvcnQYBiABKA4yHy52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudFNvcnQiowEKGUNsaWVudFNlcnZpY2VMaXN0UmVzcG9uc2USPwoFaXRlbXMYASADKAsyMC52bXNwZGIuYXBpLnByb3RvLnYxLkNsaWVudFNlcnZpY2VDcmVhdGVSZXNwb25zZRIzCgpwYWdpbmF0aW9uGAIgASgLMh8udm1zcGRiLmFwaS5wcm90by52MS5QYWdpbmF0aW9uEhAKCGRlZ3JhZGVkGAMgASgIKoABCgpDbGllbnRUeXBlEhsKF0NMSUVOVF9UWVBFX1VOU1BFQ0lGSUVEEAASGgoWQ0xJRU5UX1RZUEVfQ09OVFJBQ1RPUhABEhoKFkNMSUVOVF9UWVBFX0VORF9DTElFTlQQAhIdChlDTElFTlRfVFlQRV9TVUJDT05UUkFDVE9SEAQqdgoSQ2xpZW50Tm90aWZpY2F0aW9uEiMKH0NMSUVOVF9OT1RJRklDQVRJT05fVU5TUEVDSUZJRUQQABIcChhDTElFTlRfTk9USUZJQ0FUSU9OX1RFWFQQARIdChlDTElFTlRfTk9USUZJQ0FUSU9OX0VNQUlMEAIqkwEKCkNsaWVudFNvcnQSGwoXQ0xJRU5UX1NPUlRfVU5TUEVDSUZJRUQQABImChBDTElFTlRfU09SVF9OQU1FEAEaEJqmHQRuYW1loqYdBG5hbWUSQAoZQ0xJRU5UX1NPUlRfQlVTSU5FU1NfTkFNRRACGiGaph0NYnVzaW5lc3NfbmFtZaKmHQxidXNpbmVzc05hbWUyqwQKDUNsaWVudFNlcnZpY2USbQoGQ3JlYXRlEi8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlQ3JlYXRlUmVxdWVzdBowLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZUNyZWF0ZVJlc3BvbnNlIgASZAoDR2V0Eiwudm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlR2V0UmVxdWVzdBotLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZUdldFJlc3BvbnNlIgASbQoGVXBkYXRlEi8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlVXBkYXRlUmVxdWVzdBowLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZVVwZGF0ZVJlc3BvbnNlIgASbQoGRGVsZXRlEi8udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlRGVsZXRlUmVxdWVzdBowLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZURlbGV0ZVJlc3BvbnNlIgASZwoETGlzdBItLnZtc3BkYi5hcGkucHJvdG8udjEuQ2xpZW50U2VydmljZUxpc3RSZXF1ZXN0Gi4udm1zcGRiLmFwaS5wcm90by52MS5DbGllbnRTZXJ2aWNlTGlzdFJlc3BvbnNlIgBCKlooZ28udm1zcGRiLmFwcC9wbGF0Zm9ybS9pbnRlcm5hbC9wcm90by92MWIGcHJvdG8z',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.ClientLicenses
 */
export type ClientLicenses = Message<'vmspdb.api.proto.v1.ClientLicenses'> & {
  /**
   * @generated from field: string general_contractor_license_number = 1;
   */
  generalContractorLicenseNumber: string;

  /**
   * @generated from field: string epsc_contractor_number = 2;
   */
  epscContractorNumber: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ClientLicenses
 */
export type ClientLicensesJson = {
  /**
   * @generated from field: string general_contractor_license_number = 1;
   */
  generalContractorLicenseNumber?: string;

  /**
   * @generated from field: string epsc_contractor_number = 2;
   */
  epscContractorNumber?: string;
};

export type ClientLicensesValid = ClientLicenses;

/**
 * Describes the message vmspdb.api.proto.v1.ClientLicenses.
 * Use `create(ClientLicensesSchema)` to create a new message.
 */
export const ClientLicensesSchema: GenMessage<
  ClientLicenses,
  { jsonType: ClientLicensesJson; validType: ClientLicensesValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 0);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceGetRequest
 */
export type ClientServiceGetRequest =
  Message<'vmspdb.api.proto.v1.ClientServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceGetRequest
 */
export type ClientServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

export type ClientServiceGetRequestValid = ClientServiceGetRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceGetRequest.
 * Use `create(ClientServiceGetRequestSchema)` to create a new message.
 */
export const ClientServiceGetRequestSchema: GenMessage<
  ClientServiceGetRequest,
  {
    jsonType: ClientServiceGetRequestJson;
    validType: ClientServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 1);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceGetResponse
 */
export type ClientServiceGetResponse =
  Message<'vmspdb.api.proto.v1.ClientServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceGetResponse
 */
export type ClientServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ClientServiceGetResponseValid = ClientServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceGetResponse.
 * Use `create(ClientServiceGetResponseSchema)` to create a new message.
 */
export const ClientServiceGetResponseSchema: GenMessage<
  ClientServiceGetResponse,
  {
    jsonType: ClientServiceGetResponseJson;
    validType: ClientServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceCreateRequest
 */
export type ClientServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.ClientServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceCreateRequest
 */
export type ClientServiceCreateRequestJson = {
  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];
};

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceCreateRequest
 */
export type ClientServiceCreateRequestValid =
  Message<'vmspdb.api.proto.v1.ClientServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: AddressValid;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicensesValid;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];
  };

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceCreateRequest.
 * Use `create(ClientServiceCreateRequestSchema)` to create a new message.
 */
export const ClientServiceCreateRequestSchema: GenMessage<
  ClientServiceCreateRequest,
  {
    jsonType: ClientServiceCreateRequestJson;
    validType: ClientServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceCreateResponse
 */
export type ClientServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.ClientServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceCreateResponse
 */
export type ClientServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ClientServiceCreateResponseValid = ClientServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceCreateResponse.
 * Use `create(ClientServiceCreateResponseSchema)` to create a new message.
 */
export const ClientServiceCreateResponseSchema: GenMessage<
  ClientServiceCreateResponse,
  {
    jsonType: ClientServiceCreateResponseJson;
    validType: ClientServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceUpdateRequest
 */
export type ClientServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.ClientServiceUpdateRequest'> & {
    /**
     * BUG-039: no `required = true` here, unlike sibling *GetRequest.uuid fields.
     * string.uuid already expands to a string.uuid_empty check that rejects "",
     * so this is a naming inconsistency, not a live validation gap. Tracked, not missed.
     *
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceUpdateRequest
 */
export type ClientServiceUpdateRequestJson = {
  /**
   * BUG-039: no `required = true` here, unlike sibling *GetRequest.uuid fields.
   * string.uuid already expands to a string.uuid_empty check that rejects "",
   * so this is a naming inconsistency, not a live validation gap. Tracked, not missed.
   *
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];
};

export type ClientServiceUpdateRequestValid = ClientServiceUpdateRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceUpdateRequest.
 * Use `create(ClientServiceUpdateRequestSchema)` to create a new message.
 */
export const ClientServiceUpdateRequestSchema: GenMessage<
  ClientServiceUpdateRequest,
  {
    jsonType: ClientServiceUpdateRequestJson;
    validType: ClientServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 5);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceUpdateResponse
 */
export type ClientServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.ClientServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceUpdateResponse
 */
export type ClientServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ClientServiceUpdateResponseValid = ClientServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceUpdateResponse.
 * Use `create(ClientServiceUpdateResponseSchema)` to create a new message.
 */
export const ClientServiceUpdateResponseSchema: GenMessage<
  ClientServiceUpdateResponse,
  {
    jsonType: ClientServiceUpdateResponseJson;
    validType: ClientServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 6);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceDeleteRequest
 */
export type ClientServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.ClientServiceDeleteRequest'> & {
    /**
     * BUG-039: same deliberate non-change as ClientServiceUpdateRequest.uuid above.
     *
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceDeleteRequest
 */
export type ClientServiceDeleteRequestJson = {
  /**
   * BUG-039: same deliberate non-change as ClientServiceUpdateRequest.uuid above.
   *
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

export type ClientServiceDeleteRequestValid = ClientServiceDeleteRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceDeleteRequest.
 * Use `create(ClientServiceDeleteRequestSchema)` to create a new message.
 */
export const ClientServiceDeleteRequestSchema: GenMessage<
  ClientServiceDeleteRequest,
  {
    jsonType: ClientServiceDeleteRequestJson;
    validType: ClientServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 7);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceDeleteResponse
 */
export type ClientServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.ClientServiceDeleteResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
     */
    type: ClientType;

    /**
     * @generated from field: string business_name = 4;
     */
    businessName: string;

    /**
     * @generated from field: string email = 5;
     */
    email: string;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.Address address = 7;
     */
    address?: Address;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
     */
    notification: ClientNotification;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
     */
    licenses?: ClientLicenses;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated string associations = 11;
     */
    associations: string[];

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceDeleteResponse
 */
export type ClientServiceDeleteResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientType type = 3;
   */
  type?: ClientTypeJson;

  /**
   * @generated from field: string business_name = 4;
   */
  businessName?: string;

  /**
   * @generated from field: string email = 5;
   */
  email?: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.Address address = 7;
   */
  address?: AddressJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientNotification notification = 8;
   */
  notification?: ClientNotificationJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientLicenses licenses = 9;
   */
  licenses?: ClientLicensesJson;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated string associations = 11;
   */
  associations?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ClientServiceDeleteResponseValid = ClientServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceDeleteResponse.
 * Use `create(ClientServiceDeleteResponseSchema)` to create a new message.
 */
export const ClientServiceDeleteResponseSchema: GenMessage<
  ClientServiceDeleteResponse,
  {
    jsonType: ClientServiceDeleteResponseJson;
    validType: ClientServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceListRequest
 */
export type ClientServiceListRequest =
  Message<'vmspdb.api.proto.v1.ClientServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ClientSort sort = 6;
     */
    sort: ClientSort;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceListRequest
 */
export type ClientServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ClientSort sort = 6;
   */
  sort?: ClientSortJson;
};

export type ClientServiceListRequestValid = ClientServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceListRequest.
 * Use `create(ClientServiceListRequestSchema)` to create a new message.
 */
export const ClientServiceListRequestSchema: GenMessage<
  ClientServiceListRequest,
  {
    jsonType: ClientServiceListRequestJson;
    validType: ClientServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceListResponse
 */
export type ClientServiceListResponse =
  Message<'vmspdb.api.proto.v1.ClientServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ClientServiceCreateResponse items = 1;
     */
    items: ClientServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ClientServiceListResponse
 */
export type ClientServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ClientServiceCreateResponse items = 1;
   */
  items?: ClientServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type ClientServiceListResponseValid = ClientServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ClientServiceListResponse.
 * Use `create(ClientServiceListResponseSchema)` to create a new message.
 */
export const ClientServiceListResponseSchema: GenMessage<
  ClientServiceListResponse,
  {
    jsonType: ClientServiceListResponseJson;
    validType: ClientServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_clients, 10);

/**
 * @generated from enum vmspdb.api.proto.v1.ClientType
 */
export enum ClientType {
  /**
   * @generated from enum value: CLIENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLIENT_TYPE_CONTRACTOR = 1;
   */
  CONTRACTOR = 1,

  /**
   * @generated from enum value: CLIENT_TYPE_END_CLIENT = 2;
   */
  END_CLIENT = 2,

  /**
   * @generated from enum value: CLIENT_TYPE_SUBCONTRACTOR = 4;
   */
  SUBCONTRACTOR = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ClientType
 */
export type ClientTypeJson =
  | 'CLIENT_TYPE_UNSPECIFIED'
  | 'CLIENT_TYPE_CONTRACTOR'
  | 'CLIENT_TYPE_END_CLIENT'
  | 'CLIENT_TYPE_SUBCONTRACTOR';

/**
 * Describes the enum vmspdb.api.proto.v1.ClientType.
 */
export const ClientTypeSchema: GenEnum<ClientType, ClientTypeJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_clients, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.ClientNotification
 */
export enum ClientNotification {
  /**
   * @generated from enum value: CLIENT_NOTIFICATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLIENT_NOTIFICATION_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: CLIENT_NOTIFICATION_EMAIL = 2;
   */
  EMAIL = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ClientNotification
 */
export type ClientNotificationJson =
  | 'CLIENT_NOTIFICATION_UNSPECIFIED'
  | 'CLIENT_NOTIFICATION_TEXT'
  | 'CLIENT_NOTIFICATION_EMAIL';

/**
 * Describes the enum vmspdb.api.proto.v1.ClientNotification.
 */
export const ClientNotificationSchema: GenEnum<
  ClientNotification,
  ClientNotificationJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_clients, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.ClientSort
 */
export enum ClientSort {
  /**
   * @generated from enum value: CLIENT_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLIENT_SORT_NAME = 1;
   */
  NAME = 1,

  /**
   * @generated from enum value: CLIENT_SORT_BUSINESS_NAME = 2;
   */
  BUSINESS_NAME = 2,
}

/**
 * @generated from enum vmspdb.api.proto.v1.ClientSort
 */
export type ClientSortJson =
  'CLIENT_SORT_UNSPECIFIED' | 'CLIENT_SORT_NAME' | 'CLIENT_SORT_BUSINESS_NAME';

/**
 * Describes the enum vmspdb.api.proto.v1.ClientSort.
 */
export const ClientSortSchema: GenEnum<ClientSort, ClientSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_clients, 2);

/**
 * @generated from service vmspdb.api.proto.v1.ClientService
 */
export const ClientService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.ClientService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof ClientServiceCreateRequestSchema;
    output: typeof ClientServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ClientService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof ClientServiceGetRequestSchema;
    output: typeof ClientServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ClientService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof ClientServiceUpdateRequestSchema;
    output: typeof ClientServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ClientService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof ClientServiceDeleteRequestSchema;
    output: typeof ClientServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ClientService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof ClientServiceListRequestSchema;
    output: typeof ClientServiceListResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_clients, 0);
